/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L8_NInputs */

const en_mk_sec_pg_l8_n = /** @type {(inputs: Mk_Sec_Pg_L8_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We have neither, and we will not display a badge before a real audit.`)
};

const id_mk_sec_pg_l8_n = /** @type {(inputs: Mk_Sec_Pg_L8_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada, dan kami tidak akan memasang lencananya sebelum benar-benar diaudit.`)
};

/**
* | output |
* | --- |
* | "We have neither, and we will not display a badge before a real audit." |
*
* @param {Mk_Sec_Pg_L8_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l8_n = /** @type {((inputs?: Mk_Sec_Pg_L8_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L8_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l8_n(inputs)
	return en_mk_sec_pg_l8_n(inputs)
});